(() => {
  document.querySelectorAll('[data-gift-recipient]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const toggle = root.querySelector('[type=checkbox]');
    const fields = root.querySelector('.dac-gift-recipient__fields');
    const email = root.querySelector('[type=email]');
    const message = root.querySelector('textarea');
    const date = root.querySelector('[type=date]');
    const offset = root.querySelector('[data-gift-offset]');
    const format = value => [value.getFullYear(), String(value.getMonth()+1).padStart(2,'0'), String(value.getDate()).padStart(2,'0')].join('-');
    function dates() {
      const today = new Date();
      const last = new Date(today); last.setDate(last.getDate()+90);
      date.min = format(today); date.max = format(last);
      offset.value = String(today.getTimezoneOffset());
    }
    function sync() {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input,textarea').forEach(field => { field.disabled = !toggle.checked; });
      email.required = toggle.checked;
      toggle.setAttribute('aria-expanded', String(toggle.checked));
      root.querySelector('[data-gift-count]').textContent = message.value.length + ' / 200';
      dates();
    }
    toggle.addEventListener('change', sync);
    message.addEventListener('input', sync);
    window.addEventListener('pageshow', sync);
    root.closest('form').addEventListener('submit', event => {
      dates();
      if (toggle.checked) { email.value = email.value.trim(); message.value = message.value.trim(); root.querySelector('[data-gift-count]').textContent = message.value.length + ' / 200'; }
      if (!event.target.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    sync();
  });
})();